import type { ServiceArea } from '@/core/graphql/types'

const EARTH_RADIUS_KM = 6371

function haversineDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const dLat = ((lat2 - lat1) * Math.PI) / 180
  const dLng = ((lng2 - lng1) * Math.PI) / 180
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) ** 2
  return EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

export function isOutsideServiceArea(
  serviceArea: ServiceArea,
  postalCode?: string | null,
  coordinates?: { lat: number; lng: number } | null
): boolean {
  if (postalCode && serviceArea.allowedPostalCodes?.length) {
    const postalMatch = serviceArea.allowedPostalCodes.some(
      (code) => postalCode.startsWith(code) || postalCode === code
    )
    if (!postalMatch) return true
  }

  if (coordinates && serviceArea.center && serviceArea.radiusKm) {
    const dist = haversineDistance(
      coordinates.lat,
      coordinates.lng,
      serviceArea.center.lat,
      serviceArea.center.lng
    )
    if (dist > serviceArea.radiusKm) return true
  }

  return false
}
